import Dexie from 'dexie';

const db = new Dexie('m1');
db.version(1).stores({
    lingue: '++id', //same of db
    pacchetti: '++id, nome', // same of db + dataLettura
    traduzioni: '++id, [pacchettoId+chiave]', // + valore
});


export default db;